export const buildVersion = {
  version: '1.1',
  buildNumber: 421,
  commit: '0e356966a',
};
